import React, { useEffect, useState } from "react";

import API from "../../utils/API";
import Select from "react-select";

const LenderSelect = ({
  name,
  value,
  onChange,
  isSingle,
  lenders: providedLenders,
}) => {
  const [allLenders, setAllLenders] = useState([]);
  const [filterValue, setFilterValue] = useState([]);

  const mapValuesToFilters = (value = [], lendersList) => {
    if (!lendersList || lendersList.length === 0) {
      return [];
    }
    return value.map((item) => {
      const matchedFilter = lendersList.find((source) => source.value == item);
      return matchedFilter || item;
    });
  };

  const lendersToUse = providedLenders
    ? providedLenders.map((lender) => ({
        value: lender.id,
        label: "#" + lender.id + ", " + lender.title,
      }))
    : allLenders;

  useEffect(() => {
    if (!providedLenders) {
      API.get("/system/lenders")
        .then((response) => {
          const options = response.data.data;
          const lenders = options
            ? options.map((option) => ({
                value: option.id,
                label: "#" + option.id + ", " + option.title,
              }))
            : [];

          setAllLenders(lenders);
          // Map values after lenders are loaded
          if (lenders.length > 0 && value) {
            const mappedFilters = mapValuesToFilters(value, lenders);
            setFilterValue(mappedFilters);
          }
        })
        .catch((error) => {
          console.error("Error fetching lenders:", error);
          setAllLenders([]);
        });
    }
  }, [providedLenders]);

  // Update filterValue when value prop changes and lenders are loaded
  useEffect(() => {
    const currentLendersToUse = providedLenders
      ? providedLenders.map((lender) => ({
          value: lender.id,
          label: "#" + lender.id + ", " + lender.title,
        }))
      : allLenders;
      
    if (currentLendersToUse && currentLendersToUse.length > 0 && value) {
      const mappedFilters = mapValuesToFilters(value, currentLendersToUse);
      setFilterValue(mappedFilters);
    }
  }, [value, allLenders, providedLenders]);

  const changeSelect = (value) => {
    // Don't process if lenders haven't loaded yet
    if (!lendersToUse || lendersToUse.length === 0) {
      return;
    }
    
    if (isSingle) {
      onChange(name, value ? value.value : null);
      const mappedFilters = mapValuesToFilters(value ? [value] : [], lendersToUse);
      setFilterValue(mappedFilters);
    } else {
      const values = value ? value.map((item) => item.value) : [];
      onChange(name, values);
      const mappedFilters = mapValuesToFilters(values, lendersToUse);
      setFilterValue(mappedFilters);
    }
  };

    return (
        <Select
            className="react-select-container"
            classNamePrefix="react-select"
            options={lendersToUse || []}
            value={filterValue}
            onChange={changeSelect}
            isMulti={!isSingle}
            placeholder="Lender"
            isLoading={!providedLenders && allLenders.length === 0}
        />
    );
}

export default LenderSelect;
